export default function(target){
    if(!target){
        return
    }
    let cloneNode = target.cloneNode(true)
    const originStyle = window.getComputedStyle(target, null)
    const width = originStyle.getPropertyValue('width')
    const boxSizing = originStyle.getPropertyValue('box-sizing')
    const lineHeight = originStyle.getPropertyValue('line-height')
    const fontSize = originStyle.getPropertyValue('font-size')
    const padding = originStyle.getPropertyValue('padding')
    const border = originStyle.getPropertyValue('border')
    const paddingTop = originStyle.getPropertyValue('padding-top')
    const paddingBottom = originStyle.getPropertyValue('padding-bottom')
    const whiteSpace = originStyle.getPropertyPriority('white-space')

    cloneNode.style.width = width
    cloneNode.style['box-sizing'] = boxSizing
    cloneNode.style['line-height'] = lineHeight
    cloneNode.style.fontSize = fontSize
    cloneNode.style.padding = padding
    cloneNode.style.border = border
    cloneNode.style.position = 'absolute'
    cloneNode.style.left = '-9999px'
    cloneNode.style.visiblity = 'hidden'
    cloneNode.style['white-space'] = whiteSpace
    
    document.body.appendChild(cloneNode)
    // console.log(cloneNode.offsetHeight)
    const nodeHeight = cloneNode.offsetHeight;
    const contentHeight = nodeHeight - paddingTop.replaceAll('px','') - paddingBottom.replaceAll('px','')
    // console.log('contentHeight',contentHeight)
    const line = Math.ceil(contentHeight/lineHeight.replaceAll('px',''))
    //移除cloneNode
    document.body.removeChild(cloneNode)
    return line
}